var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7032 0.288997C14.0959 0.677358 14.0994 1.31051 13.711 1.70319L6.78793 8.70319C6.60008 8.89312 6.34405 9 6.07692 9C5.80979 9 5.55376 8.89312 5.36592 8.70319L2.289 5.59208C1.90064 5.1994 1.90413 4.56625 2.29681 4.17789C2.68949 3.78953 3.32264 3.79302 3.711 4.1857L6.07692 6.57791L12.289 0.296811C12.6774 -0.0958652 13.3105 -0.0993633 13.7032 0.288997ZM17.7071 3.29289C18.0976 3.68342 18.0976 4.31658 17.7071 4.70711L6.70711 15.7071C6.31658 16.0976 5.68342 16.0976 5.29289 15.7071L0.292893 10.7071C-0.0976311 10.3166 -0.0976311 9.68342 0.292893 9.29289C0.683417 8.90237 1.31658 8.90237 1.70711 9.29289L6 13.5858L16.2929 3.29289C16.6834 2.90237 17.3166 2.90237 17.7071 3.29289Z",
    fill: "59FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCheck);
export default __webpack_public_path__ + "static/media/double-check.8f1cfda18c99ff9cad3d873c827e26db.svg";
export { ForwardRef as ReactComponent };